import { produce } from 'immer'

import { UNCATEGORIZED_TAGS } from '../../utils/constants'

// Action Types
export const SET_CATEGORIES = 'organizationTagManager/setCategories'
export const ADD_CATEGORY = 'organizationTagManager/addCategory'
export const UPDATE_ORDER_OF_TAGS = 'organizationTagManager/updateOrderOfTags'
export const SET_TAGS = 'organizationTagManager/setTags'

// Action Creators
export const setCategories = (payload) => ({ type: SET_CATEGORIES, payload })
export const addCategory = (payload) => ({ type: ADD_CATEGORY, payload })
export const setTags = (payload) => ({ type: SET_TAGS, payload })
export const updateOrderOfTags = (payload) => ({ type: UPDATE_ORDER_OF_TAGS, payload })

// State
export const initialState = {
  column: {},
  tags: {},
  columnOrder: [],
}

// Reducer
export default function organizationTagManagerReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CATEGORIES: {
      return produce(initialState, (newState) => {
        action.payload.forEach((category) => {
          const categoryId = `category-${category.id}`
          newState.columnOrder.push(categoryId)
          newState.column[categoryId] = {
            id: categoryId,
            categoryId: category.id,
            title: category.name,
            organizationId: category.organization_id,
            taskIds: [],
            sortId: category.sort_id,
          }
        })
        newState.columnOrder.push('column-1')
        newState.column['column-1'] = { id: 'column-1', title: UNCATEGORIZED_TAGS, taskIds: [] }
      })
    }
    case SET_TAGS: {
      return produce(state, (newState) => {
        newState.tags = {}
        // Rebuild column membership from the payload so repeated or interleaved
        // fetches can't append the same tag twice.
        Object.values(newState.column).forEach((column) => {
          column.taskIds = []
        })
        action.payload.forEach((tag) => {
          const tagId = `tag-${tag.id}`
          // A tag whose category column isn't loaded still renders (as uncategorized)
          // rather than silently vanishing while the tag counts include it.
          const column =
            (tag.tag_category_id && newState.column[`category-${tag.tag_category_id}`]) ||
            newState.column['column-1']
          if (column) {
            column.taskIds.push(tagId)
          }
          newState.tags[tagId] = {
            id: tagId,
            tagId: tag.id,
            content: tag.name,
            organizationId: tag.organization_id,
            tagCategoryId: tag.tag_category_id,
          }
        })
      })
    }
    case ADD_CATEGORY: {
      return produce(state, (newState) => {
        const categoryId = `category-${action.payload.id}`
        // The uncategorized column stays last so the rendered category
        // Draggables keep consecutive columnOrder indices, which rbd requires.
        const uncategorizedIndex = newState.columnOrder.indexOf('column-1')
        if (uncategorizedIndex === -1) {
          newState.columnOrder.push(categoryId)
        } else {
          newState.columnOrder.splice(uncategorizedIndex, 0, categoryId)
        }
        newState.column[categoryId] = {
          id: categoryId,
          categoryId: action.payload.id,
          title: action.payload.name,
          organizationId: action.payload.organization_id,
          taskIds: [],
          sortId: action.payload.sort_id,
        }
      })
    }
    case UPDATE_ORDER_OF_TAGS:
      return action.payload
    default:
      return state
  }
}
